/* eslint-disable no-shadow */
import React from 'react';
import { SingleSelect } from '@els/els-react--select';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import './ProjectParametersUtils.scss';

export function PopupRow({ children, className }) {
  return <div className={cn('rs-column', className)}>{children}</div>;
}

export function ReadOnlyRow({ children, className }) {
  return <div className={cn('rs-readonly-row', className)}>{children}</div>;
}

export function RsDropdown({ options, onChange = () => null, value, e2eName = '' }) {
  if (isEmpty(options)) {
    return null;
  }
  return (
    <div className="rs-column-single-select">
      <SingleSelect
        className={`e2eName-${e2eName}`}
        size="small"
        options={options}
        value={value.value}
        data-e2e={e2eName}
        selectedOptions={[value.value || '']}
        optionsFlyoutProps={{ noInternalPadding: true, theme: 'default', placement: 'bottom', pointer: true, pointerType: 'primary' }}
        onSelect={({ value }) => onChange(value)}
        label={e2eName}
        shouldHideLabel
        required
      />
    </div>
  );
}
